/**
 * Зависимости
 */
import {Utils} from '@/common/scripts/utils';
import {YANDEX_API_URL} from '@/common/scripts/constants';
import YandexMap from '@/components/yandex-map';

const mainMap = document.querySelector('.j-contacts-map');
let yandexMap = null;

export const initContactsMap = () => {
    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper          : mainMap,
                cluster          : true,
                customZoomControl: true,
                disableMobileDrag: false
            });
        });
    }
};

if (mainMap) {
    const ymaps = window.ymaps;

    if (ymaps) {
        initContactsMap(mainMap);
    } else {
        Utils.loadScript(YANDEX_API_URL, initContactsMap.bind(null, mainMap));
    }
}
